import store from "@/store";
import DcbService from "@/services/dcbService";
import getUserSessionData from "@/functions/getUserSessionData";
import {handleActionClick} from "./handleActionClick";
import {Brands} from "../brand/brandConfig";
import {ServiceIds, setServiceIds} from "../config";
import DepService from "@/services/depService";
import setUserSessionData from "@/functions/setUserSessionData";
import TelkomService from "@/services/telkomService";

export async function userAuthenticate(to, from, next) {
    const {brand} = store.state.brandConfig;
    setServiceIds(brand);
    await userAuthenticateNormalFlow(to, from, next);
}

// async function userAuthenticateEncryptedFlow(to, from, next) {
//     if (store.state.user || to.name === 'Wifi' || to.name === 'DoiTwo' || to.name === 'TimeoutError') {
//         store.commit('setIsLoading', false);
//         return next();
//     }
//     store.commit('setIsLoading', true);
//     const urlParams = new URLSearchParams(window.location.search);
//     const token = urlParams.get('token') ?? localStorage.getItem('token');
//     const encryptedMsisdn = urlParams.get('encryptedMsisdn') ?? localStorage.getItem('encryptedMsisdn');
//     const campaignId = urlParams.get('campaignId') || urlParams.get('cid');
//     const googleClickId = urlParams.get('gclid');
//     const clickId = urlParams.get('clickId');
//
//     if (campaignId) setCampaignId(campaignId)
//     if (googleClickId) setGoogleClickId(googleClickId)
//     if (clickId) setClickId(clickId)
//     if (encryptedMsisdn && token) {
//         return await storeUserDetails(encryptedMsisdn, token, next);
//     } else {
//         store.commit('setIsLoading', false);
//         return next({name: 'Wifi'});
//     }
// }

async function userAuthenticateNormalFlow(to, from, next) {
    store.commit('setIsLoading', true);
    if (checkUserState(to)) {
        store.commit('setIsLoading', false);
        return next();
    } else {
        const userSessionData = getUserSessionData();
        if (userSessionData.msisdn) await setUserData(userSessionData.msisdn, next, to);
    }
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedMsisdn = urlParams.get('e-msisdn');
    const campaignId = urlParams.get('campaignId') || urlParams.get('cid');
    const googleClickId = urlParams.get('gclid');
    const clickId = urlParams.get('clickId');
    const userSessionData = getUserSessionData();
    const msisdn = urlParams.get('msisdn')

    if (!msisdn && !userSessionData.msisdn) return sendUserBackForSubscription(next);
    if (msisdn) await setUserData(msisdn, next, to);
    if (campaignId) setCampaignId(campaignId)
    if (googleClickId) setGoogleClickId(googleClickId)
    if (clickId) setClickId(clickId)
    if (encryptedMsisdn) return await encryptedMsisdnAuth(encryptedMsisdn, next);

    store.commit('setIsLoading', false);
    return next();
}

function setCampaignId(campaignId) {
    store.commit('setCampaignId', campaignId);
}

function setGoogleClickId(googleClickId) {
    store.commit('setGoogleClickId', googleClickId);
}

function setClickId(clickId) {
    store.commit('setClickId', clickId);
}

function sendUserBackForSubscription() {
    return window.open('https://sdp-p-vas-payment.telkom.co.za/300000091', '_self');
}

async function storeUserDetails(encryptedMsisdn, token, next) {
    const userDataResponse = await getUser(encryptedMsisdn, token);
    await setEncryptedUserData(userDataResponse, token, encryptedMsisdn);
    return await redirectBasedOnUserStatusMarketingFlow(userDataResponse.data, next);
}

async function redirectBasedOnUserStatusMarketingFlow(user, next) {
    //TODO look at this logic !!
    store.commit('setIsLoading', false);
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get('action');

    if (user.status === "Active" && user.Service !== ServiceIds.free) return next({name: 'LandingPage'});
    else if (user.status === 'Content Blocked') return next({ path: `/error/:${user.status}` })
    else if (action) return await handleActionClick(user, action, next);
    else return next({name: 'DoiTwo'});
    // Need to implement this page else if(user?.contentBlockedEnabled) return next({name: 'ContentBlockOptIn'});
}

async function getUser(encryptedMsisdn, token) {
    const serviceId = await getMultiTierServiceV2(token);
    return await DcbService.getUserViaEncryptedMsisdn(encryptedMsisdn, token, serviceId);
}

async function setEncryptedUserData(userDataResponse, token = undefined, encryptedMsisdn = undefined) {
    await DcbService.trackLoginV2(token);
    store.commit('setUser', userDataResponse.data);
    store.commit('setToken', token);
    store.commit('setEncryptedMsisdn', encryptedMsisdn);
    localStorage.setItem('token', token);
    localStorage.setItem('encryptedMsisdn', encryptedMsisdn);
}

async function encryptedMsisdnAuth(encryptedMsisdn, next) {
    const decryptMsisdnResponse = await DcbService.decryptMsisdn(encryptedMsisdn);
    return await redirectBasedOnUserStatus(next);
}

async function getMultiTierServiceV2(token) {
    const getMultiTierServiceResponse = await DcbService.getMultiTierServiceV2(token, store.state.productId);
    const getServiceIdByDescriptionResponse = getServiceIdByDescription(getMultiTierServiceResponse.data);
    setServiceIdValues(getServiceIdByDescriptionResponse);
    return getServiceIdByDescriptionResponse
}

function setServiceIdValues(serviceId) {
    localStorage.setItem('serviceId', serviceId);
    store.commit('setServiceId', serviceId);
}

async function redirectBasedOnUserStatus(next) {
    const userResponse = (await TelkomService.getUser(msisdn, store.state.productId)).data.user
    store.commit('setUser', userResponse);
    store.commit('setIsLoading', false);
    if (!userResponse) next({name: 'WelcomePage'});
    if (userResponse.username === null) return next({name: 'CreateUsername'});
    else return next({name: 'LandingPage'});
}

function getServiceIdByDescription(array) {
    return array[0].Description;
}

function checkUserState(to) {
    if (store.state.user || to.name === 'TermsConditions') return true
    else return false
}

async function setUserData(msisdn, next, to) {
    store.commit('setMsisdn', msisdn);
    const user = (await TelkomService.getUser(msisdn, store.state.productId)).data.user
    if (user.Service === 'telkom-melody-madness-free') return sendUserBackForSubscription();
    if (user.Status !== 'ACTIVE' && user.Status !== 'PENDING' && user.Status !== "SUSPENDED") return sendUserBackForSubscription();
    setUserSessionData(msisdn, user.Service)
    store.commit('setServiceId', user.Service);
    store.commit('setUser', user);
    store.commit('setIsLoading', false);
    if (to.path === '/login') return next({name: 'LandingPage'})
    else next();
}
